import { NationalFlagEmblem } from '../../components/ui/NationalFlagEmblems';
import { FOOTBALL_LEAGUE_COUNT, FOCUSED_LEAGUE_ID, identityFor } from '../../data/leagues';
import { CardHeader, CoverageRow, ListCard, LiveTag, SoonTag } from './shared';

// ── Step 2 · Football leagues ─────────────────────────────────────────────────
const FOOTBALL_ROWS = [
  { leagueId: FOCUSED_LEAGUE_ID, live: true },
  { leagueId: 'premier-league', live: false },
  { leagueId: 'la-liga', live: false },
  { leagueId: 'serie-a', live: false },
  { leagueId: 'superliga', live: false }
] as const;

export function FootballCard() {
  return (
    <ListCard>
      <CardHeader
        label="Football leagues"
        trailing={
          <span className="num text-[11px] font-bold tabular-nums text-ink3">
            {FOOTBALL_LEAGUE_COUNT} total
          </span>
        }
      />
      <div className="flex flex-col gap-[7px]">
        {FOOTBALL_ROWS.map(({ leagueId, live }) => {
          const identity = identityFor(leagueId);
          return (
            <CoverageRow
              key={leagueId}
              emblem={
                <NationalFlagEmblem leagueId={leagueId} country={identity?.country} size="xs" />
              }
              name={identity?.name ?? leagueId}
              sub={live ? 'Live now' : 'New season soon'}
              live={live}
              trailing={live ? <LiveTag /> : <SoonTag />}
            />
          );
        })}
      </div>
    </ListCard>
  );
}
